import React, { createContext, useContext, useState } from 'react';

// Contexto para manejar fecha seleccionada y dashboard lateral
const DateContext = createContext();

export const useDateContext = () => {
  const context = useContext(DateContext);
  if (!context) {
    throw new Error('useDateContext must be used within a DateProvider');
  }
  return context;
};

export const DateProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isDashboardOpen, setIsDashboardOpen] = useState(false);

  const openDashboard = () => setIsDashboardOpen(true);
  const closeDashboard = () => setIsDashboardOpen(false);
  const toggleDashboard = () => setIsDashboardOpen(!isDashboardOpen);

  const selectDate = (date) => {
    setSelectedDate(date);
    openDashboard();
  };

  const value = {
    selectedDate,
    setSelectedDate,
    isDashboardOpen,
    openDashboard,
    closeDashboard,
    toggleDashboard,
    selectDate
  };

  return <DateContext.Provider value={value}>{children}</DateContext.Provider>;
};

export default DateContext;
